import { settingsCharm_ariaLabel } from 'owa-locstrings/lib/strings/settingscharm_arialabel.locstring.json';
import loc from 'owa-localize';
import * as React from 'react';
import * as ReactDOM from 'react-dom';
import HeaderCharm from './HeaderCharm';

import { HeaderCharmType } from 'owa-header-store';
import { SettingsPane } from 'owa-header-pane';
import { observer } from 'mobx-react-lite';
import { ControlIcons } from 'owa-control-icons';
import { SettingIconFirstRunCallout } from 'owa-header-fre';
import { eventMgr, SettingPanelFirstRunCalloutDismissedEvent, LightningId } from 'owa-lightning-v2';
import { WebPushDiscovery } from 'owa-webpush-notifications';

export default observer(function SettingsCharm(props: {}) {
    const target = React.useRef<HeaderCharm>(null);
    const getTarget = React.useCallback(
        () => ReactDOM.findDOMNode(target.current) as HTMLElement,
        []
    );
    const activateSettingsCharmCallout = React.useCallback(
        (lightup: () => void) =>
            eventMgr.on(SettingPanelFirstRunCalloutDismissedEvent, () =>
                setTimeout(() => lightup(), 500)
            ),
        []
    );

    return (
        <div>
            <HeaderCharm
                ref={target}
                key="settings"
                icons={{ iconName: ControlIcons.Settings }}
                title={loc(settingsCharm_ariaLabel)}
                ariaLabel={loc(settingsCharm_ariaLabel)}
                behavior={{
                    paneComponent: SettingsPane,
                    charm: HeaderCharmType.SettingsCharm,
                }}
            />
            <SettingIconFirstRunCallout
                lid={LightningId.SettingIconFirstRunCallout}
                when={activateSettingsCharmCallout}
                series={[
                    LightningId.AnimatedConsumerRefreshFRE2,
                    LightningId.SettingPanelFirstRunCallout,
                    LightningId.SettingIconFirstRunCallout,
                ]}
                target={getTarget}
            />
            <WebPushDiscovery calloutTarget={getTarget} />
        </div>
    );
});
